const buildStars = (productId, score, count, color_star, bg_color_star) => {
  const yotpoStars = document.querySelector(`#yotpo-custom-${productId} .yotpo-custom__stars`);
  const fullStars = Math.floor(score);
  const partialStar = Number((score - fullStars).toFixed(1));
  let starsHTML = '<div class="star-container yotpo-sr-star-full" style="display: flex; flex-direction: row;">';

  for(let i = 0; i < fullStars; i++) {
    starsHTML += `
      <svg viewBox="0 0 18 18" tabindex="0" xmlns="http://www.w3.org/2000/svg" role="img" width="15" height="15" aria-label="Star ${i+1} out of 5">
        <defs>
          <linearGradient aria-hidden="true" id="yotpo_stars_gradient_${i}">
            <stop offset="100%" stop-color="${color_star}"></stop>
            <stop stop-opacity="1" offset="100%" stop-color="${bg_color_star}"></stop>
          </linearGradient>
        </defs>
        <path aria-hidden="true" style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="${color_star}" fill="url('#yotpo_stars_gradient_${i}')"></path>
      </svg>`;
  }

  if(partialStar > 0) {
    const gradientId = `yotpo_stars_gradient_partial_${productId}`;
    starsHTML += `
      <svg viewBox="0 0 18 18" tabindex="0" xmlns="http://www.w3.org/2000/svg" role="img" width="15" height="15" aria-label="Star ${fullStars+1} out of 5">
        <defs>
          <linearGradient id="${gradientId}">
            <stop offset="${Math.round(partialStar * 100)}%" stop-color="${color_star}"></stop>
            <stop stop-opacity="1" offset="${Math.round(partialStar * 100)}%" stop-color="${bg_color_star}"></stop>
          </linearGradient>
        </defs>
        <path aria-hidden="true" style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="${color_star}" fill="url('#${gradientId}')"></path>
      </svg>`;    
  }

  for(let i = Math.ceil(score); i < 5; i++) {
    starsHTML += `
      <svg viewBox="0 0 18 18" tabindex="0" xmlns="http://www.w3.org/2000/svg" role="img" width="15" height="15" aria-label="Star ${i+1} out of 5">
        <defs>
          <linearGradient aria-hidden="true" id="yotpo_stars_gradient_empty_${i}">
            <stop offset="0%" stop-color="${color_star}"></stop>
            <stop stop-opacity="1" offset="0%" stop-color="${bg_color_star}"></stop>
          </linearGradient>
        </defs>
        <path aria-hidden="true" style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="${color_star}" fill="url('#yotpo_stars_gradient_empty_${i}')"></path>
      </svg>`;
  }
  starsHTML += '</div>';
  yotpoStars.innerHTML = starsHTML;
  const yotpoReviewsValue = document.querySelector(`#yotpo-custom-${productId} .yotpo-custom__reviews-value`);
  const yotpoReviewsCount = document.querySelector(`#yotpo-custom-${productId} .yotpo-custom__reviews-count`);
  yotpoReviewsValue.innerHTML = score.toFixed(1);
  yotpoReviewsCount.innerHTML = `(${count})`;
}

const getYotpoAverageScore = async (appKey, productId, color_star, bg_color_star) => {
  const res = await fetch(`https://api.yotpo.com/v1/widget/${appKey}/products/${productId}/reviews.json`);
  const json = await res.json();
  const score = json?.response?.bottomline?.average_score;
  const count = json?.response?.bottomline?.total_review;
  const build = await buildStars (productId, score, count, color_star, bg_color_star);
  return build;
}

window.searchYotpoElement = () => {
  const { appKey, colorStar, bgColorStar } = window.yotpoCustom;
  const yotpoElements = document.querySelectorAll('.yotpo-custom__container');
  const processedElements = new Set();

  if (yotpoElements) {
    const observer = new IntersectionObserver((entries, observerInstance) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const productId = el.dataset.productId;
          if (productId && !processedElements.has(productId)) {
            getYotpoAverageScore(appKey, productId, colorStar, bgColorStar);
            processedElements.add(productId);
            observerInstance.unobserve(el);
          }
        }
      });
    }, {
      rootMargin: '500px 0px 0px 0px'
    });

    yotpoElements.forEach(el => {
      const productId = el.dataset.productId;
      if (productId && !processedElements.has(productId)) {
        observer.observe(el);
      }
    });
  }
}